"use client";
import { Select } from "@/components/Select";
import { getLastCategory } from "@/helpers";
import { Dropdown } from "@/types/General/Dropdown";
import { FC, useState } from "react";

type FilterProps = {
  selectAllText?: string;
  multiple?: boolean;
  placeholder: string;
  options: string[];
  selectedFilters: string[];
  onFilter: (paths: string[]) => void;
};

export const Filter: FC<FilterProps> = ({
  selectAllText,
  options,
  placeholder,
  multiple = false,
  selectedFilters,
  onFilter,
}) => {
  const [isSelectAllSelected, setIsSelectAllSelected] = useState(false);
  const placeholderDropdown = {
    label: placeholder,
    value: placeholder,
  };
  const optionsWithSelectAllText = [
    ...(selectAllText ? [selectAllText] : []),
    ...options,
  ];

  return multiple ? (
    <Select
      selectedDecoration="checkbox"
      formControlContainerClassName="bg-background"
      multipleSelectionDisplayLabel={placeholder}
      value={
        selectedFilters.length
          ? [
              ...(selectAllText && options.length === selectedFilters.length
                ? [selectAllText]
                : []),
              ...selectedFilters,
            ].map((selectedFilter) => ({
              label: getLastCategory(selectedFilter),
              value: selectedFilter,
            }))
          : [placeholderDropdown]
      }
      onChange={(selectedValue: Dropdown[]) => {
        const isSelectAllAmongSelected = selectedValue.some(
          ({ label }) => selectAllText === label,
        );
        const selectedOptionsFromFilter = selectedValue.filter(
          ({ value }) => value !== selectAllText && value !== placeholder,
        );
        // select all
        if (
          isSelectAllAmongSelected &&
          selectedFilters.length !== options.length &&
          selectedOptionsFromFilter.length !== options.length
        ) {
          onFilter(options);
          setIsSelectAllSelected(true);
        } else {
          // deselect all
          if (
            selectAllText &&
            isSelectAllSelected &&
            !isSelectAllAmongSelected
          ) {
            onFilter([]);
            setIsSelectAllSelected(false);
          } else {
            onFilter(selectedOptionsFromFilter.map(({ value }) => value));
            if (selectedOptionsFromFilter.length === options.length) {
              setIsSelectAllSelected(true);
            } else {
              setIsSelectAllSelected(false);
            }
          }
        }
      }}
      multiple={multiple}
      variant="rectangular"
      options={optionsWithSelectAllText.map((option) => ({
        label: getLastCategory(option),
        value: option,
      }))}
    />
  ) : (
    <Select
      selectedDecoration="radio"
      formControlContainerClassName="bg-background"
      value={
        selectedFilters.length
          ? {
              label: placeholder,
              value: selectedFilters[0],
            }
          : placeholderDropdown
      }
      onChange={(selectedValue: Dropdown) => {
        if (selectedValue?.value) {
          onFilter([selectedValue.value]);
        }
      }}
      multiple={multiple}
      variant="rectangular"
      options={options.map((option) => ({
        label: option,
        value: option,
      }))}
    />
  );
};
